import { gql } from '../../../artifacts/gql';

export const addAddressMutation = gql(`
  mutation webAddAddressMutation($input: AddressCreateInputV2!) {
    addressCreateV2(input: $input) {
      successful
      result {
        id
      }
      messages {
        message
        code
        field
      }
    }
  }
`);
